import { RouteComponentProps } from "@reach/router"
import { AddAssetModal_s, AssetList_s } from "components/asset-management/asset-list/asset-list-styles"
import AssetListTable from "components/asset-management/asset-list/asset-list-table"
import { Errors } from "components/asset-management/errors"
import DropdownInput from 'components/inputs/dropdown'
import Modal from 'components/modal/basic-modal'
import ConfirmationAutomation from 'components/modal/confirmation-automation'
// Components
import { Toolbar } from "components/subnav"
import assetListService from "data/asset-list"
import automationService from "data/automation"
import chartService from "data/chart"
// Data
import api_match from "data/interface/api"
import keyService, * as chord from "data/key"
import validationService from 'data/validate'
// Styles
import { AddIcon } from "images/icons/tools"
import React, { FC, useEffect, useState } from 'react'
import Isvg from 'react-inlinesvg'
import { ButtonWithPress_s, Button_s } from 'styles/app-styles'
// Inputs
import { InputText_s } from 'styles/input-styles'

const AssetList: FC<RouteComponentProps> = (props) => {
  const [data, setData] = useState<object[]>([])
  const [charts, setCharts] = useState<object[]>([])
  const [showModal, toggleModal] = useState<boolean>(false);
  const [name, setName] = useState<string>("");
  const [code, setCode] = useState<string>("")
  const [propertyType, setPropertyType] = useState<string>("Commercial")
  const tableId = "asset-list-table"

  useEffect(() => {
    validationService.validate('asset')
  },[])

  useEffect(() => {
    const assetListSubscription = assetListService.stream().subscribe(data => {
      api_match(
        data,
        init  => setData(init.value),
        ok    => {
          setData(ok.value)
        },
        err   => {
          setData(err.value) // backout any optimistic updates
        },
        fetch => {}
      )
    })
    const chartSubscription = chartService.stream().subscribe(data => {
      api_match(
        data,
        init  => setCharts(init.value),
        ok    => {
          setCharts(ok.value)
        },
        err   => {
          setCharts(err.value) // backout any optimistic updates
        },
        fetch => {}
      )
    })
    assetListService.fetchAssets()
    chartService.fetchCharts()

    return function cleanup() {
      assetListSubscription.unsubscribe()
      chartSubscription.unsubscribe()
    }
  }, [])

  useEffect(() => {
    keyService.stream().subscribe(k => {
      if (k.chord === chord.ESC && showModal) cancelModal()
    })
  }, [showModal])

  const Add = () => {
    return (
      <a onClick={()=>toggleShow()}>
        <Isvg src={AddIcon} width="20px" />
      </a>
    )
  }

  const cancelModal = () => {
    toggleModal(false)
    setName("")
    setCode("")
    setPropertyType("Commercial")
    setTimeout(() => automationService.broadcast("MODAL_CLOSING", {}), 200)
  }

  const toggleShow = () => {
    if (showModal){
      cancelModal()
    } else {
      toggleModal(true)
      automationService.broadcast("MODAL_OPENING", {})
    }
  }

  const submitNewAsset = () => {
    assetListService.create(code, name, propertyType);
    cancelModal();
  }

  return (
    <AssetList_s>
      <Toolbar>
        <Add />
        <Errors />
      </Toolbar>
      {showModal && <Modal show={showModal} title="Add New Asset" toggleShow={toggleShow} width={300}>
          <AddAssetModal_s id="addAssetModal">
            <div>
              <label htmlFor="propertyTypeInput">Property Type</label>
              <DropdownInput
                className="automated"
                id="propertyTypeInput"
                field="propertytype"
                options={[{value: 'Commercial', label: 'Commercial'},{value: 'Multifamily', label: 'Multifamily'},{value: 'Hospitality', label: 'Hospitality'}]}
                persist={(field:string, val:string)=>setPropertyType(val)}
                value={propertyType}
              />
            </div>
            <div>
              <label htmlFor="nameInput">Code</label>
              <InputText_s
                className="automated"
                id="codeInput"
                value={code}
                onChange={(e) => setCode((e.target as HTMLInputElement).value)}
              />
            </div>
            <div>
              <label htmlFor="nameInput">Name</label>
              <InputText_s
                className="automated"
                id="nameInput"
                value={name}
                onChange={(e) => setName((e.target as HTMLInputElement).value)}
              />
            </div>
            <div>
              <Button_s onClick={cancelModal}>Cancel</Button_s>
              <ButtonWithPress_s primary onClick={()=>submitNewAsset()}>
                Save
              </ButtonWithPress_s>
            </div>
          </AddAssetModal_s>
          <ConfirmationAutomation />
        </Modal> }
      { data.length > 0 && <AssetListTable tableId={tableId} data={data} /> }
    </AssetList_s>
  )
}

export default AssetList
